import page15 from "./Page15.webp";
import page16 from "./Page16.webp";
import page17 from "./Page17.webp";
import page18 from "./Page18.webp";
import page19 from "./Page19.webp";
import page20 from "./Page20.webp";
import page21 from "./Page21.webp";
// import page22 from "./Page22.webp";

export const heritagePages = [
  page15,
  page16,
  page17,
  page18,
  page19,
  page20,
  page21,
];
